/* global translations */
/* eslint jsx-a11y/anchor-is-valid: 'off' */
import React, { Component } from 'react';
import get from 'lodash/get';
import { ImageSvg } from '../image';
import SuggestionsExtendedStore from '../../stores/SuggestionsExtendedStore';

class ExtendedFormAttachments extends Component {
  state = {
    title: SuggestionsExtendedStore.getAttachmentsTitle(),
    files: {},
  };

  componentDidMount() {
    SuggestionsExtendedStore.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    SuggestionsExtendedStore.removeChangeListener(this.onChange);
  }

  onChange = () => {
    this.setState({
      title: SuggestionsExtendedStore.getAttachmentsTitle(),
      files: SuggestionsExtendedStore.getAttachments(),
    });
  };

  onFilesAdd = (e) => {
    const { files } = this.state;
    Object.values(e.target.files).forEach((file) => {
      if (!Object.prototype.hasOwnProperty.call(files, file.name)) {
        files[file.name] = file;
      }
    });

    SuggestionsExtendedStore.setAttachments(files);
    SuggestionsExtendedStore.setSubmitStatus(null);
    SuggestionsExtendedStore.emitChange();
  };

  onFileRemove = (e, filename) => {
    e.preventDefault();

    const { files } = this.state;
    if (!Object.prototype.hasOwnProperty.call(files, filename)) {
      return;
    }

    delete files[filename];

    SuggestionsExtendedStore.setAttachments(files);
    SuggestionsExtendedStore.setSubmitStatus(null);
    SuggestionsExtendedStore.emitChange();
  };

  render() {
    const { title, files } = this.state;
    const filenames = Object.keys(files);

    return (
      <div>
        <div className="mtl mbs mlxs twb">{title}</div>
        <label
          htmlFor="Files"
          className="btn btn--light btn--iconLeft btn--small mts"
        >
          <span className="btn-static">
            <span className="vcenter">
              <span className="vcenter-inner">
                <ImageSvg svg="icon-paperclip" iconClass="icon--paperclip" full />
              </span>
            </span>
          </span>
          <span className="tcb">
            {get(translations, 'txt: Pievienot pielikumu', 'txt: Pievienot pielikumu')}
          </span>
        </label>
        <input
          type="file"
          id="Files"
          name="files[]"
          multiple="multiple"
          accept="image/*,video/*,application/msword,application/pdf"
          hidden="1"
          onChange={this.onFilesAdd}
        />
        {filenames.length > 0 && (
          <div className="mtm">
            {filenames.map((filename) => (
              <p
                key={filename}
                className="mtxs mbf mls tsi"
              >
                {filename}
                <a
                  href="#"
                  className="tcb mlm"
                  onClick={(e) => this.onFileRemove(e, filename)}
                >
                  {get(translations, 'txt: Noņemt pielikumu', 'txt: Noņemt pielikumu')}
                </a>
              </p>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default ExtendedFormAttachments;
